import { css } from '@emotion/react';

export const appStyles = {
  paddingComponent: (props: any) => css`
    padding: ${props.theme.container.padding};
  `,
  borderGray: (props: any) => css`
    border: 1px solid ${props.theme.color.grayBorder};
  `,
  /** 0.75rem */
  borderRadiusModal: (props: any) => css`
    border-radius: ${props.theme.modal.borderRadius};
  `,
  /** 0.75rem */
  borderRadiusPreview: (props: any) => css`
    border-radius: 0.75rem;
  `,
  /** 6px */
  commonBorderRadius: () => css`
    border-radius: 6px;
  `,
  fullWidthHeight: () => css`
    width: 100%;
    height: 100%;
  `,
  searchInput: (props: any) => css`
    font-weight: 600;
    font-size: 0.875rem;
    height: 36px;
    padding-right: 5px;
    ${appStyles.commonBorderRadius()}
    .ant-input-suffix {
      background-color: ${props.theme.color.inputSuffix};
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      .anticon {
        color: ${props.theme.color.white};
      }
    }
  `,
  inputStyle: (props: any) => css`
    border-radius: 6px;
    height: 36px;
  `,
  commonModalContentStyle: (props: any) => css`
    padding: ${props.theme.modal.contentPadding};
    border-radius: ${props.theme.modal.borderRadius};
  `,
  commonItemMarginBottom: (props: any) => css`
    margin-bottom: ${props.theme.itemMarginBottom};
  `,
  commonButtonSubmitted: (props: any) => css`
    bottom: 0;
    right: ${props.theme.modal.btnPadding};
    position: absolute !important;
  `,
  color: {
    default: (props: any) => css`
      color: ${props.theme.color.default};
    `,
    white: (props: any) => css`
      color: ${props.theme.color.white};
    `,
    black: (props: any) => css`
      color: ${props.theme.color.black};
    `,
    error: (props: any) => css`
      color: ${props.theme.color.error};
    `,
    darkTheme: (props: any) => css`
      color: ${props.theme.darkTheme.color};
    `,
    red: (props: any) => css`
      color: ${props.theme.color.red} !important;
    `,
    orange: (props: any) => css`
      color: ${props.theme.color.orange} !important;
    `,
    green: (props: any) => css`
      color: ${props.theme.color.green} !important;
    `,
  },
  background: {
    black: (props: any) => css`
      background: ${props.theme.color.black};
    `,
    white: (props: any) => css`
      background: ${props.theme.color.white};
    `,
    modalBgGray: (props: any) => css`
      background: ${props.theme.color.modalBgGray};
    `,
    bgUploadImage: (props: any) => css`
      background: ${props.theme.color.bgUploadImage};
    `,
    tableBgGray: (props: any) => css`
      background: ${props.theme.color.tableBgGray};
    `,
  },
};

export const activeDefault = (props: any) =>
  css`
    background: ${props.theme.color.activeDefault};
    border-color: ${props.theme.color.activeDefault};
  `;

export const btnActive = (props: any) =>
  css`
    button.ant-btn {
      background: ${props.theme.color.btnBgDefault};
      border-color: ${props.theme.color.btnBgDefault};
      &.delete {
        color: ${props.theme.color.red};
      }
      &.active {
        background: ${props.theme.color.active};
        border-color: ${props.theme.color.active};
        color: ${props.theme.color.white};
      }
    }
  `;

export const selectSelector = (props: any) =>
  css`
    .ant-select-selector {
      border-radius: 6px !important;
    }
  `;

export const formScrolling = (props: any) =>
  css`
    .form-scroll {
      min-height: 350px;
      height: 480px;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 0.5rem;
    }
  `;
export const defaultImage = (props: any) =>
  css`
    .default-image {
      ${appStyles.borderGray(props)}
      background: transparent linear-gradient(180deg, #7a91be 0%, #4e5157 100%) 0% 0% no-repeat padding-box;
      border-radius: ${props.theme.modal.borderRadius};
      & .heading {
        top: -25px;
        left: -1px;
      }
    }
  `;
